var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-container" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "SP-RR-002", name: "SP-RR-002" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "top-bar" },
            [
              _c("el-date-picker", {
                staticClass: "date-picker",
                attrs: {
                  placeholder: _vm.$t("operationCenter.SelectDate"),
                  "prefix-icon": "el-icon-time",
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.queryDate,
                  callback: function ($$v) {
                    _vm.queryDate = $$v
                  },
                  expression: "queryDate",
                },
              }),
              _c(
                "div",
                { staticClass: "btn-group" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-search", type: "success" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("userManage.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-download",
                        plain: "",
                        type: "success",
                      },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "cards-row" },
            [
              _c("div", { staticClass: "card total-card" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.$t("Resource.todayTotalWorkload"))),
                ]),
                _c("div", { staticClass: "card-value" }, [
                  _vm._v(_vm._s(_vm.summaryData.total)),
                ]),
                _c("div", { staticClass: "card-footer" }, [
                  _c(
                    "span",
                    {
                      staticClass: "label",
                      staticStyle: { "margin-right": "20px" },
                    },
                    [_vm._v(_vm._s(_vm.$t("Resource.comparedToYesterday")))]
                  ),
                  _c(
                    "span",
                    {
                      class: [
                        "trend",
                        _vm.summaryData.trendArrow === "↑" ? "up" : "down",
                      ],
                    },
                    [
                      _c("i", {
                        class:
                          _vm.summaryData.trendArrow === "↑"
                            ? "el-icon-top"
                            : "el-icon-bottom",
                      }),
                      _vm._v(" " + _vm._s(_vm.summaryData.trendDiff) + " "),
                    ]
                  ),
                ]),
              ]),
              _vm._l(_vm.summaryData.details, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "card detail-card" },
                  [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(_vm._s(item.value)),
                    ]),
                    _c("div", { staticClass: "card-footer" }, [
                      _c(
                        "span",
                        {
                          staticClass: "label",
                          staticStyle: { "margin-right": "20px" },
                        },
                        [_vm._v(_vm._s(_vm.$t("trajectory.Proportion")))]
                      ),
                      _c("span", { staticClass: "percent" }, [
                        _vm._v(_vm._s(item.percent)),
                      ]),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "chart-section" }, [
        _c("div", { staticClass: "chart-title" }, [
          _c("i", {
            staticClass: "el-icon-trend-charts",
            staticStyle: { color: "#2d9a4f", "margin-right": "6px" },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("Resource.workloadTrend24h")))]),
        ]),
        _c("div", {
          ref: "lineChart",
          staticStyle: { height: "300px", width: "100%" },
        }),
      ]),
      _c("div", { staticClass: "chart-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("i", { staticClass: "el-icon-s-data chart-icon" }),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Resource.warehouseEfficiencyComparison"))),
          ]),
        ]),
        _c("div", { ref: "mainChart", staticClass: "chart-box" }),
      ]),
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _c("div", { staticClass: "section-header" }, [
            _c("i", { staticClass: "el-icon-s-grid table-icon" }),
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("Resource.hourlyWorkloadDetails"))),
            ]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#000000",
                  fontWeight: "bold",
                },
                "summary-method": _vm.getSummaries,
                border: "",
                "show-summary": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("trajectory.Time"),
                  align: "center",
                  prop: "time",
                  width: "180",
                },
              }),
              _vm._l(_vm.columns, function (col, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: { label: col.label, prop: col.prop, align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row[col.prop] > 0
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(scope.row[col.prop]) + " "
                                  ),
                                  _c("span", { staticClass: "percent-text" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          scope.row[col.prop + "Percent"]
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ])
                              : _c("span", [_vm._v("0")]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.totalWorkload"),
                  align: "center",
                  prop: "total",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("strong", [_vm._v(_vm._s(scope.row.total))])]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }